// reducers.js

import * as ActionTypes from "./actionsTypes";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
  companyIdSuccess:null,
  companyIdError:null
};

const linkedinReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.VALIDATE_ACCESS_TOKEN_REQUEST:
      return {
        ...state,
        isLoading: true,
        data: null,
        error: null,
      };

    case ActionTypes.VALIDATE_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null,
      };

    case ActionTypes.VALIDATE_ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: null,
        error: action.error,
      };
    case ActionTypes.SAVE_LINKEDIN_COMPANY_REQUEST:
      return { ...state,isLoading:true, companyIdSuccess: "", companyIdError: null };
    case ActionTypes.SAVE_LINKEDIN_COMPANY_SUCCESS:
      return { ...state,isLoading:false, companyIdSuccess: action.message, companyIdError: null };
    case ActionTypes.SAVE_LINKEDIN_COMPANY_FAILURE:
      return { ...state,isLoading:false, companyIdSuccess: "", companyIdError: action.error };

    default:
      return state;
  }
};

export default linkedinReducer;
